import { assertNonNullishProperties } from "api/client/helpers/assertNonNullishProperties";
import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
import { CodeFile, ToolVersion } from "graphql/_Types";
import { JsonValue } from "type-fest";
import { formatFilename } from "../helpers/formatFilename";
import { getFilePartSize } from "../helpers/getFilePartSize";

type CreateCodeFileInput = Pick<CodeFile, "id" | "tenantId" | "name"> & {
  size: number;
  bundle_metadata: JsonValue;
  tool_version: ToolVersion["id"];
  checksum: string;
};
export const codeFileCreate = djangoClientQueryFactory(
  { path: "/drs/code_file/", method: "post" },
  {
    formatInput: ({
      id,
      name,
      size,
      tenantId,
      bundle_metadata,
      checksum,
      tool_version,
    }: CreateCodeFileInput) => {
      return {
        body: {
          id,
          name: formatFilename(name),
          size,
          bundle_metadata,
          tool_version,
          tenant: tenantId,
          uploaded: true,
          checksum,
          date_created: new Date().toISOString(),
          part_size: getFilePartSize(size),
        },
      };
    },
    handleResponse: (res) => {
      const file = res.data;
      assert(file !== undefined, "Expected file to be defined");
      assertNonNullishProperties(file, ["id", "size", "part_size"]);
      return file;
    },
  },
);
